import React from 'react'
import { amphtml } from '../../../google-amp/react_amp'

interface InnerProps {
    width: number
    height: number
    layout: 'responsive'
    'data-tweetid': string
}
const AmpTwitterElement = amphtml<InnerProps>('twitter')

export interface AmpTwitterProps {
    tweetId: string
    width: number
    height: number
}

export const AmpTwitter: React.FC<AmpTwitterProps> = (props) => (
    <AmpTwitterElement
        width={props.width}
        height={props.height}
        layout="responsive"
        data-tweetid={props.tweetId}
    />
)
